export default {
	label: 'Vara | Varad',
	info: 'Detailid',
	inventoryNr: 'Lao nr',
	history: {
		label: 'Ajalugu',
		empty: 'Ajalugu puudub',
		removedConnections: 'Eemaldatud seosed',
		addedConnections: 'Lisatud seosed',
		StandardModuleAsset: 'Moodul',
		BusinessProcess: 'Äriprotsess',
		connectionsUpdated: 'uuendati seoseid',
		fieldsUpdated: 'uuendati välju',
		created: 'uus vara loodud',
	},
	risks: {
		label: 'Ohud',
		none: 'Puuduvad seotud riskid',
		connect: 'Seo vara äriprotsessi või mooduliga.',
		default: 'Riski põhiseosed',
		connection: 'Riski varaseosed',
		blockTitle: 'Vara ei saa kustutada',
		blockMessage: 'See vara on otse seotud järgmiste riskidega. Eemaldage või määrake need ümber enne vara kustutamist:',
	},
	status: {
		label: 'Staatus',
		active: 'Aktiivne',
		notActive: 'Mitte aktiivne',
		connectionMissing: 'Aktiivne (puudub äriprotsessi/mooduli seos!)',
	},
	titles: {
		CustomFields: 'Lisa väljad',
		Responsible: 'Vastutav',
		Comment: 'Kommentaar',
		Location: 'Asukoht',
		Price: 'Hind',
		Status: 'Staatus',
		Name: 'Nimi',
		InventoryNr: 'Lao number',
		Active: 'Staatus',
	},
	sub: 'Alamvara | Alamvarad',
	addSub: 'Lisa alamvara',
	editConnections: 'Muuda seoseid',
}
